export default {
    LOAD_ACCOUNT_BANK(state, account_bank) {
        state.items = account_bank;
    }
}